<div class="search-bar">
  <app-search-form [placeholder]="'Search'"></app-search-form>
  <button (click)="refresh()"><mat-icon>refresh</mat-icon></button>
</div>
<div class="app-page-container" style="padding:10px 10px 10px 10px;">
  <app-writeups-list
    [deals]="deals"
    [loading]="loading"
    [searchText]="searchText"
    [currentUser]="currentUser"
    [selectedManagerId]="selectedManagerId"
    (dealSelected)="onSelectDeal($event)"
    [isSalesManager]="true">
  </app-writeups-list>
</div>
